import React, { useEffect, useState } from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  TableContainer, 
  Table, 
  TableHead, 
  TableRow, 
  TableCell, 
  TableBody, 
  Button, 
  CircularProgress 
} from '@mui/material';
import { listSynthesisConfigurations } from '../../services/synthesisConfigService';
import { SynthesisConfigurationResponse } from '../../types/synthesisConfig';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';

const SynthesisConfigurationsList: React.FC = () => {
  const [configs, setConfigs] = useState<SynthesisConfigurationResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const fetchConfigurations = async () => {
    setLoading(true);
    try {
      const data = await listSynthesisConfigurations();
      setConfigs(data);
    } catch (error) {
      console.error('Erro ao buscar configurações do Synthesis:', error);
      swal('Erro', 'Não foi possível buscar as configurações do Synthesis.', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfigurations();
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h5">Configurações do Publisol Synthesis</Typography>
        <Button variant="contained" onClick={() => navigate('/synthesis/configurations/novo')}>
          Nova Configuração
        </Button>
      </Box>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Nome da Entidade</TableCell>
                <TableCell>Endereço</TableCell>
                <TableCell>Data de Criação</TableCell>
                <TableCell>Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {configs.map((config) => (
                <TableRow key={config.id}>
                  <TableCell>{config.id}</TableCell>
                  <TableCell>{config.entity_name}</TableCell>
                  <TableCell>
                    {config.address.street} - {config.address.cep}
                  </TableCell>
                  <TableCell>{new Date(config.created_at).toLocaleString()}</TableCell>
                  <TableCell>
                    <Button 
                      variant="outlined" 
                      size="small" 
                      onClick={() => navigate(`/synthesis/configurations/${config.id}`)}
                    >
                      Ver
                    </Button>
                    <Button 
                      variant="outlined" 
                      size="small" 
                      onClick={() => navigate(`/synthesis/configurations/${config.id}/editar`)}
                      sx={{ ml: 1 }}
                    >
                      Editar
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
              {configs.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    Nenhuma configuração encontrada.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default SynthesisConfigurationsList;